var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59076 10.88C8.10597 8.45277 10.2614 6.63174 12.8421 6.63174C15.807 6.63174 18.2105 9.03525 18.2105 12.0001C18.2105 14.965 15.807 17.3685 12.8421 17.3685C12.348 17.3685 11.9474 17.7691 11.9474 18.2632C11.9474 18.7574 12.348 19.158 12.8421 19.158C16.7953 19.158 19.9999 15.9533 19.9999 12.0001C19.9999 8.04696 16.7953 4.84229 12.8421 4.84229C9.20822 4.84229 6.20681 7.5502 5.74569 11.0582L4.52758 9.8401C4.17817 9.49069 3.61166 9.49069 3.26224 9.8401C2.91283 10.1895 2.91283 10.756 3.26224 11.1054L5.94643 13.7896C6.29584 14.139 6.86236 14.139 7.21177 13.7896L9.89596 11.1054C10.2454 10.756 10.2454 10.1895 9.89596 9.8401C9.54654 9.49069 8.98003 9.49069 8.63062 9.8401L7.59076 10.88Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcn);
export default __webpack_public_path__ + "static/media/clear-icn.44c05e7b10ec5a48316211e896d51eb3.svg";
export { ForwardRef as ReactComponent };